import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { selectedEventsAtom } from '../../atom';

const EmptyArray: any[] = [];

export const useItemList = ({ eventList, selectedSession }) => {
  const selectedEvents = useAtomValue(selectedEventsAtom);

  const isTimelineEmpty = eventList.length === 0;

  const topItemList = useMemo(() => {
    if (!selectedSession.sessionId || isTimelineEmpty) {
      return [{ id: 'empty-view' }];
    }
    const res = [{ id: 'session-info' }];
    if (selectedEvents && selectedEvents.length > 0) {
      res.push({ id: 'session-summary' });
    }
    res.push({ id: 'start' });
    return res;
  }, [isTimelineEmpty, selectedEvents, selectedSession.sessionId]);

  const bottomItemList = useMemo(() => {
    if (!selectedSession.sessionId || isTimelineEmpty) {
      return EmptyArray;
    }
    return [{ id: 'end' }];
  }, [isTimelineEmpty, selectedSession]);

  return {
    timelineItems: { topItemList, bottomItemList },
  };
};
